import Component from './ErrorBoundary'

export default Component
